module.exports = __webpack_public_path__ + "static/media/24-2.16d5788b.mp3";